module.exports = __webpack_public_path__ + "img/icon-Script-Blue.531003d4.png";